/**
 * AAA-IDP Loading component
 * 
 */
import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Loading.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Loading = props => {
  const {
    text
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: "Loading",
    children: [text ? /*#__PURE__*/_jsx("p", {
      children: text
    }) : null, /*#__PURE__*/_jsx(FontAwesomeIcon, {
      icon: "spinner",
      spin: true
    })]
  });
};
Loading.defaultProps = {
  text: ''
};
export default Loading;